import React, {PureComponent} from 'react';
import {RadialBarChart, RadialBar, Legend, PolarAngleAxis} from 'recharts';
import randomColour from 'randomcolor'

const data = [
    {
        name: '18-24', uv: 50, fill: '#8884d8',
    },
    {
        name: '25-29', uv: 50, fill: '#83a6ed',
    },
    {
        name: '30-34', uv: 15.69, fill: '#8dd1e1',
    },
    {
        name: '35-39', uv: 8.22, fill: '#82ca9d',
    },
    {
        name: '40-49', uv: 8.63, fill: '#a4de6c',
    },
    {
        name: '50+', uv: 2.63, fill: '#d0ed57',
    },
    {
        name: 'unknow', uv: 50, fill: '#ffc658',
    },
];

const style = {
    top: 0,
    left: 350,
    lineHeight: '24px',
};


export default class Example extends PureComponent {


    render() {

        const {budgets, total_budget, total_fees} = this.props

        const formattedBudgets = (budgets && budgets.length) ? budgets.map(budget =>
            ({...budget, percentage_budget_used: ((budget.budget_used + budget.supplier_total) / budget.budget_total) * 100})) : []

        return (
            <RadialBarChart width={200} height={200} cx={100} cy={100} innerRadius={20} outerRadius={100} barSize={7}
                            data={formattedBudgets}>
                <PolarAngleAxis type="number" domain={[0, 100]} angleAxisId={0} tick={false}
                                dataKey="percentage_budget_used"/>
                <RadialBar data={formattedBudgets[0]} angleAxisId={0} background clockWise
                           dataKey="percentage_budget_used" fill={randomColour({luminosity: 'light'})}/>
            </RadialBarChart>
        )
    }
}
